import { render } from "./ModalName.vue?vue&type=template&id=72999a0b"
import script from "./ModalName.vue?vue&type=script&lang=js"
export * from "./ModalName.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__